// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const clientBriefConfirmInBriefHashMax = 64;

export const ClientBriefConfirmIn = zod.object({
  "brief_hash": zod.string().min(1).max(clientBriefConfirmInBriefHashMax)
});

export type ClientBriefConfirmIn = zod.input<typeof ClientBriefConfirmIn>;
export type ClientBriefConfirmInOutput = zod.output<typeof ClientBriefConfirmIn>;
